import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [{
  path: 'admin',
  loadChildren: () => import('@rensa/modules/admin/admin.module').then(m => m.AdminModule)
}, {
  path: 'host',
  loadChildren: () => import('@rensa/modules/host/host.module').then(m => m.HostModule)
}, {
  path: '',
  pathMatch: 'prefix',
  loadChildren: () => import('@rensa/modules/customer/customer.module').then(m => m.CustomerModule)
}, {
  path: '*',
  redirectTo: ''
}];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'corrected', scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
